export function getTranslateValue(value: String, params?: any, lang?: String): String{
    let translation: String = '';
    switch(lang){
      case 'en':
        translation = params.obj[`${params.property}English`] ?? 
          params.obj[`${params.property}En`] ?? '';
        break;
      case 'es':
        translation = params.obj[params.property] ?? '';
        break;
      default:
        translation = value;
    }

    return translation;
  }
